import {
    createSelector,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { apiSlice } from '@/app/api/apiSlice'

const userMagicMomentsAdapter = createEntityAdapter({})

const initialState = userMagicMomentsAdapter.getInitialState()

export const userMagicMomentsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getUserMagicMoments: builder.query({
            query: (userId) => ({
                url: `/userMagicMoments/getUserMagicMoments/${userId}`,
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                }
            }),
            transformResponse: responseData => {
                const loadedUserMagicMoments = responseData.map(userMagicMoment => {
                    userMagicMoment.id = userMagicMoment._id
                    return userMagicMoment
                })
                return userMagicMomentsAdapter.setAll(initialState, loadedUserMagicMoments)
            },
            providesTags: (result, error, arg) => {
                if(result?.ids) {
                    return [
                        {type: 'UserMagicMoment', id: 'LIST'},
                        ...result.ids.map(id => ({ type: 'UserMagicMoment', id}))
                    ]
                } else {
                    return [ { type: 'UserMagicMoment', id: 'LIST'}]
                }
            },
        }),
    }),
})

export const {
    useGetUserMagicMomentsQuery,
} = userMagicMomentsApiSlice

// returns the query result object
export const selectUserMagicMomentResult = userMagicMomentsApiSlice.endpoints.getUserMagicMoments.select()

// create memoized selector
const selectUserMagicMomentsData = createSelector(
    selectUserMagicMomentResult,
    userMagicMomentResult => userMagicMomentResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllUserMagicMoments,
    selectById: selectUserMagicMomentById,
    selectIds: selectUserMagicMomentIds,
} = userMagicMomentsAdapter.getSelectors(state => selectUserMagicMomentsData(state) ?? initialState)